// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/circuit-spacing-and-active-runway.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/circuit-spacing-and-active-runway/circuit-spacing-and-active-runway.js';

mount([g0]);
